// Registers the PWA service worker (production builds only).
// Kept side-effect-light and failure-tolerant so it never blocks the app.
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // Avoid registering in dev (CRA dev server / hot reload) to prevent stale caches.
  const isLocalhost = ["localhost", "127.0.0.1", ""].includes(window.location.hostname);
  if (process.env.NODE_ENV !== "production" || isLocalhost) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // When a new SW takes control, refresh once so users get the latest assets.
        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });

        // Ask a SW that has finished installing to activate immediately.
        const promote = (worker) => {
          if (worker && worker.postMessage) worker.postMessage("SKIP_WAITING");
        };

        // A new SW may already be waiting when we register (installed on a prior
        // visit but never activated because the old SW still controls the page).
        if (registration.waiting && navigator.serviceWorker.controller) {
          promote(registration.waiting);
        }

        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              promote(installing);
            }
          });
        });

        // Force an update check now (and when the tab regains focus) so a fresh
        // deploy is detected without waiting for the browser's periodic check.
        const checkForUpdate = () => registration.update().catch(() => {});
        checkForUpdate();
        window.addEventListener("focus", checkForUpdate);
      })
      .catch(() => {
        /* registration failures are non-fatal */
      });
  });
}
